import React, { useState } from "react";
import Modal from "../Global/Modal";
import { FiCreditCard } from "react-icons/fi";
import PrimaryBtn, { SecondaryBtn } from "../Global/Button";
import { useMutation } from "@tanstack/react-query";
import { serverPOST } from "@/utils/HttpFunctions";
import { errorNotfiy } from "../Global/Toast";
import { GiCheckMark } from "react-icons/gi";
export default function PaymentModal({ handleBack, handleLogout }) {
  const [frequency, setFrequency] = useState("yearly");
  const { mutate: createMutate, isPending: createPending } = useMutation({
    mutationFn: (body: { planType: string }) =>
      serverPOST("/stripe/create-checkout-session", body),
    onError: (error, variables, context) => {
      errorNotfiy("Something went wrong while making payment");
    },
    onSuccess: (data, variables, context) => {
      if (data.url) {
        // window.open(data.url, "_blank");
        window.open(data.url, "_self");
      }
    },
  });

  const handleCheckout = () => {
    const body = {
      planType: frequency,
      quantity: 1,
    };
    createMutate(body);
  };

  return (
    <Modal
      title={"Flexible Pricing"}
      central={true}
      width="max-w-xl"
      handleClose={undefined}
      description="You’re in control. You can cancel anytime during the trial, and you won’t be billed unless you choose to continue after the trial period."
      icon={<FiCreditCard />}
    >
      <div className="max-w-2xl mx-auto bg-white rounded-3xl mt-4 relative">
        <div className="flex justify-end m-4 absolute -top-[160px] -right-4">
          <button
            className={`px-4 py-2 focus:outline-none font-medium  text-customGreen-text hover:opacity-80`}
            onClick={handleLogout}
            type="button"
          >
            Logout
          </button>
        </div>
        <div className="border w-fit rounded-lg flex text-base font-medium mb-3 mx-auto">
          <button
            type="button"
            className={`min-w-24 px-4 py-2 rounded-lg  ${frequency === "monthly" ? "bg-brand-600 text-white" : "bg-white text-black-secondary"}`}
            onClick={() => setFrequency("monthly")}
          >
            Monthly
          </button>
          <button
            type="button"
            className={`min-w-24 px-4 py-2 rounded-lg  ${frequency === "yearly" ? "bg-brand-600 text-white" : "bg-white text-black-secondary"}`}
            onClick={() => setFrequency("yearly")}
          >
            Yearly
          </button>
        </div>
        <div className="border border-gray-200 rounded-lg">
          <div className="flex flex-col md:flex-row gap-x-5 justify-between items-start md:items-center bg-brand-25 p-6">
            <div>
              <p className="text-black-secondarymb-2">Base Price</p>
              <p className="text-4xl text-black-secondary font-semibold flex items-end">
                {frequency === "monthly" ? "$48" : "$38"}{" "}
                <span className="font-light text-xs">
                  {frequency === "yearly" && ".40"}
                </span>
              </p>
              <p className="text-black-secondary">/seat/month</p>
              {frequency === "yearly" && (
                <span className="text-black-secondary text-xs flex items-center gap-x-1">
                  <p className="text-black-secondary text-xs font-medium">
                    Total:
                  </p>
                  <p className="text-black-secondary text-xs">$460.80</p>
                </span>
              )}
            </div>
            <p className="text-black-secondary max-w-sm mt-4 md:mt-0">
              No tiers, no confusion—just one plan with built-in discounts as
              your team grows.
            </p>
          </div>

          <div className="border-t  border-gray-100 p-6">
            <div className="flex items-baseline mb-2 text-black-secondary">
              <p>
                <span className="font-bold">Free Trial:</span>
                <span className="ml-2">Start with</span>
                <span className="font-bold mx-1">30 days</span>
                <span>
                  of unrestricted access to explore all features, completely
                  free.
                </span>
              </p>
            </div>
            <div>
              <h3 className="text-base text-gray-700 font-semibold my-4">
                Team Discounts
              </h3>
              <div className="flex items-center gap-x-4">
                <div className="bg-brand-600 min-w-8 h-8 rounded-xl flex justify-center items-center">
                  <GiCheckMark size={14} className="text-white" />
                </div>
                <div>
                  <span className="text-base font-normal text-gray-700">
                    For <span className="font-medium">5+ team members</span>,
                    receive{" "}
                    <span className="font-medium">
                      {" "}
                      {frequency === "yearly"
                        ? "10% discount ($34.56 per user/month - Total $414.72)."
                        : "10% discount ($43.20 per user/month)."}
                    </span>
                  </span>
                </div>
              </div>
              <div className="flex items-center gap-x-4 mt-4">
                <div className="bg-brand-600 min-w-8 h-8 rounded-xl flex justify-center items-center">
                  <GiCheckMark size={14} className="text-white" />
                </div>
                <div>
                  <span className="text-base font-normal text-gray-700">
                    For <span className="font-medium">10+ team members</span>,
                    receive{" "}
                    <span className="font-medium">
                      {" "}
                      {frequency === "yearly"
                        ? "20% discount ($30.72 per user/month - Total $368.64)."
                        : "20% discount ($38.40 per user/month)."}
                    </span>
                  </span>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div className="flex justify-end gap-4 items-center pt-4">
          {/* <div className="pl-4 space-x-3"> */}
          <SecondaryBtn text={"Go Back"} onClick={handleBack} />
          <PrimaryBtn
            text={"Continue"}
            loading={createPending}
            disabled={createPending}
            onClick={handleCheckout}
          />
          {/* </div> */}
        </div>
      </div>
    </Modal>
  );
}
